import EntityService from '@/modules/common/services/entityService'
import Order from '@/modules/order/domain/order'
import orderResource from '@/modules/order/services/orderResource'

const orderService = new EntityService<Order>(orderResource, Order)

export default orderService
